import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'
import { wording } from "src/constants/constants.js";

export const FETCH_WORK_ORDER_SHARE = 'FETCH_WORK_ORDER_SHARE'
export const RECEIVE_WORK_ORDER_SHARE = 'RECEIVE_WORK_ORDER_SHARE'
export const FAILED_WORK_ORDER_SHARE = 'FAILED_WORK_ORDER_SHARE'

export function fetchWorkOrderShare(_id){

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_WORK_ORDER_SHARE});
        axios({
            method: 'post',
            // !!!!! Change link when API is ready !!!!!
            url: API_LINKS.DELIVERY_CHECK_IN_LOG_URL,
            headers: {
                Authorization: auth
            },
            data: {
                // !!!!! Change data when API is ready !!!!!
                id_delivery_order: '175'
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_WORK_ORDER_SHARE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if(error.response){
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_WORK_ORDER_SHARE
                    })
                    return toast.error("Unathorized access!");
                    
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_WORK_ORDER_SHARE
                    })
                    return toast.error("Failed in fetching "+wording["Delivery Order"]+"s List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_WORK_ORDER_SHARE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_WORK_ORDER_SHARE
                    })
                    return toast.error("Please contact your system adminitrator")
                }
            }else if (error.request) {
                dispatch({
                    type: FAILED_WORK_ORDER_SHARE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_WORK_ORDER_SHARE
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}